import { render, staticRenderFns } from "./MdCategory.vue?vue&type=template&id=63762f80&scoped=true&"
import script from "./MdCategory.vue?vue&type=script&lang=js&"
export * from "./MdCategory.vue?vue&type=script&lang=js&"
import style0 from "./MdCategory.vue?vue&type=style&index=0&id=63762f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63762f80",
  null
  
)

export default component.exports